/**
 * 鏈駕駛艙共用 helpers：狀態 note 解析、顏色映射、時間格式化
 */

/** chain currentStatus → Tag 顏色（與 ChainTable 一致） */
export const chainStatusColorMap: Record<string, string> = {
  LIVE_VERIFIED: 'green',
  INTEGRATION_VERIFIED: 'blue',
  PARTIALLY_CONNECTED: 'orange',
  MODULES_EXIST_BUT_CHAIN_BROKEN: 'red',
  NOT_STARTED: 'default',
};

/** evidenceLevel → Tag 顏色（與 ChainTable 一致） */
export const evidenceColorMap: Record<string, string> = {
  LIVE_VERIFIED: 'green',
  INTEGRATION_VERIFIED: 'cyan',
  E2E_VERIFIED: 'blue',
  UNIT_VERIFIED: 'geekblue',
  MODULE_EXISTS: 'orange',
  ROUTE_REGISTERED: 'gold',
  UNKNOWN: 'default',
};

/** businessDomain → Tag 顏色（與 ChainTable 一致） */
export const domainColorMap: Record<string, string> = {
  Sales: 'blue',
  Purchase: 'green',
  Inventory: 'cyan',
  'R&D': 'purple',
  QC: 'magenta',
  HR: 'volcano',
  Finance: 'gold',
  Production: 'orange',
  System: 'geekblue',
};

/** 側欄用的精簡狀態標籤 */
export const shortStatusMap: Record<string, string> = {
  LIVE_VERIFIED: 'LIVE',
  INTEGRATION_VERIFIED: 'INT',
  PARTIALLY_CONNECTED: 'PART',
  MODULES_EXIST_BUT_CHAIN_BROKEN: 'BROKEN',
  NOT_STARTED: 'N/S',
};

/**
 * 解析狀態欄位 note 的「值=說明」對照。
 * note 格式如「狀態 D=待核 P=已核 N=已沖銷」，解析成 { D: '待核', P: '已核', N: '已沖銷' }。
 * 解析不出任何 pair 時回空物件（呼叫端原樣顯示值）。
 */
export function parseStatusNote(note: string | null | undefined): Record<string, string> {
  const result: Record<string, string> = {};
  if (!note) return result;
  const re = /([A-Za-z0-9]+)\s*=\s*([^\s,;，；、]+)/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(note)) !== null) {
    result[m[1]] = m[2];
  }
  return result;
}

/** 狀態值翻譯：有對照 →「D（待核）」；沒有 → 原樣 */
export function translateStatusValue(value: string, noteMap: Record<string, string>): string {
  const label = noteMap[value];
  return label ? `${value}（${label}）` : value;
}

/** unknown 值安全轉字串（rows / statusValues 動態欄位用） */
export function cellText(v: unknown): string {
  if (v === null || v === undefined) return '';
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
}

/** HH:mm:ss 最後刷新時間 */
export function formatRefreshTime(d: Date | null): string {
  if (!d) return '--';
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const ss = String(d.getSeconds()).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
}
